import { Button, useTheme } from '@archipro-design/aria';
import { useFetcher } from '@remix-run/react';
import { DESIGN_BOARD_HOME_LINK } from '~/modules/design-board/config';
import type { DesignBoardWithDetailedPinsFragment } from 'generated/graphql';
import BoardActionWithLoginPrompt from '@modules/design-board/component/board-detail/BoardActionWithLoginPrompt';

interface FollowBoardButtonProps {
    handleFollow?: () => void;
    board: DesignBoardWithDetailedPinsFragment;
}

const FollowBoard = ({ handleFollow, board }: FollowBoardButtonProps) => {
    const fetcher = useFetcher<never>();
    const theme = useTheme();

    const darkOutlinedButtonBorderNormal = `1px solid ${theme.siteVariables.colors.charcoal[250]}`;

    const idString = board.ID.toString();
    const data = { designBoardId: idString, boardTitle: board.Title };
    const signInRedirectLink = `${DESIGN_BOARD_HOME_LINK}/${board.URLSegment}?follow=${idString}`;

    const onFollow = () => {
        fetcher.submit(data, {
            method: 'post',
            action: '/remix-api/design-board/follow-design-board',
        });
    };

    let handleFollowEvent = handleFollow || onFollow;

    return (
        <BoardActionWithLoginPrompt
            action={
                <Button
                    variant="outlined"
                    color="dark"
                    onClick={() => handleFollowEvent()}
                    variables={{
                        buttonPadding: 16,
                        iconPadding: 4,
                        darkOutlinedButtonBorderNormal,
                    }}
                >
                    FOLLOW BOARD
                </Button>
            }
            customRedirect={signInRedirectLink}
        />
    );
};

export default FollowBoard;
